var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeave = function SvgWeave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M465 0h-22v8h22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M1350 0h-22v8h22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M222 0H0v8h222z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M443 0H221v8h222z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M665 0H465v8h200z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M886 0H665v8h221z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M1107 0H886v8h221z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M1328 0h-221v8h221z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M1440 0h-90v8h90z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#223838",
    d: "M797 32h-22v8h22z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M997 32H797v8h200z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M1019 32h-22v8h22z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M1218 32h-199v8h199z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M1440 32h-222v8h222z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M133 32h-22v8h22z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#223838",
    d: "M554 32H355v8h199z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M775 32H554v8h221zM111 32H0v8h111zM355 32H133v8h222z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M1440 64h-111v8h111z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M1329 64h-199v8h199z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M1130 64h-22v8h22zM908 64h-22v8h22z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M886 64H687v8h199z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M687 64h-22v8h22z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M665 64H466v8h199z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M245 64h-22v8h22z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M223 64H0v8h223z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M466 64h-22v8h22z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M444 64H245v8h199zM1108 64H908v8h200z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M133 96H0v8h133z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M332 96H133v8h199z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M576 96H332v8h244z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#223838",
    d: "M775 96H576v8h199z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M996 96H797v8h199z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M1241 96H996v8h245zM775 96h22v8h-22z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M1241 96h199v8h-199zM222 128H0v8h222zM443 128H244v8h199z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M222 128h22v8h-22zM443 128h22v8h-22z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M886 128h22v8h-22z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#223838",
    d: "M1108 128h22v8h-22z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M1130 128h199v8h-199z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#223838",
    d: "M1329 128h22v8h-22z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCCCB",
    d: "M1351 128h89v8h-89zM908 128h200v8H908z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5321",
    d: "M465 128h200v8H465z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M665 128h221v8H665z"
  })));
};
export default SvgWeave;